import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../Home/index'
import About from '../About'
import Contact from '../Contact'
import ErrorPage from '../ErrorPage'
import Services from '../Services'
function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home/>} />
        <Route path="/About-Us"  element={<About/>} />
        <Route path="/Contact-Us" element={<Contact/>} />
        <Route path="/Services" element={<Services/>} />
        <Route path="*" element={<ErrorPage/>} />
      </Routes>
    </Router>

  )
}

export default App
